import * as types from './actionTypes';

const initialState = {
  isLoaded: false,
  isLoading: false,
  list: {},
  compositeList: [],
  blog: {
    isInitialised: false,
    list: [],
  },
};

export default function pageReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_COMPOSITE_LIST_REQUEST:
    case types.FETCH_COMPOSITE_DETAIL_REQUEST:
    case types.FETCH_REQUEST:
      return { ...state, isLoading: true, isLoaded: false, error: '' };

    // пока пусть сохраняется в compositeList, тк приходит [], а не {}
    case types.FETCH_COMPOSITE_LIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        compositeList: action.payload.data,
      };
    }

    case types.FETCH_COMPOSITE_DETAIL_SUCCESS:
    case types.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        list: { ...state.list, [action.payload.alias]: { ...action.payload.data } },
      };

    case types.FETCH_COMPOSITE_LIST_FAILURE:
    case types.FETCH_COMPOSITE_DETAIL_FAILURE:
    case types.FETCH_FAILURE:
      return { ...state, isLoading: false, isLoaded: false, error: action.payload.error };

    case types.SEPARATE_BLOG_PAGES:
      return { ...state, blog: { isInitialised: true, list: action.payload ?? [] } };

    default:
      return state;
  }
}
